import { render, staticRenderFns } from "./DishesManagement.vue?vue&type=template&id=4d44865e&scoped=true"
import script from "./DishesManagement.vue?vue&type=script&lang=ts"
export * from "./DishesManagement.vue?vue&type=script&lang=ts"
import style0 from "./DishesManagement.vue?vue&type=style&index=0&id=4d44865e&prod&lang=css"
import style1 from "./DishesManagement.vue?vue&type=style&index=1&id=4d44865e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d44865e",
  null
  
)

export default component.exports